import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, Users, Trophy } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check if user is logged in
  React.useEffect(() => {
    const token = localStorage.getItem('token') || localStorage.getItem('adminToken');
    setIsLoggedIn(!!token);
  }, [location]);

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'À Propos', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Football Academy', path: '/football' },
    { name: 'Installations', path: '/facilities' },
    { name: 'Avis', path: '/avis' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  // Logo dynamique : Logo BLANC Football circulaire pour page Football, Logo ORANGE EM pour les autres (sport)
  const logoUrl = location.pathname === '/football'
    ? 'https://customer-assets.emergentagent.com/job_em-fitness/artifacts/cbx8x5ku_IMG_7128.jpeg' // Logo blanc Football Academy circulaire
    : 'https://customer-assets.emergentagent.com/job_em-fitness/artifacts/l1grm42g_IMG_7129.jpeg'; // Logo orange EM COACHING
  
  const isFootballPage = location.pathname === '/football';

  return (
    <header className="fixed top-0 w-full bg-black/95 backdrop-blur-sm z-50 border-b border-zinc-800">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={logoUrl}
              alt="EM Coaching"
              className="h-12"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-red-600 ${
                  isActive(link.path) ? 'text-red-600' : 'text-gray-300'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:0489822709" className="text-gray-300 hover:text-red-600 transition-colors">
              <Phone className="w-5 h-5" />
            </a>
            {isLoggedIn ? (
              <Link to={localStorage.getItem('adminToken') ? '/admin/dashboard' : '/dashboard'}>
                <Button className="bg-red-600 hover:bg-red-700 text-white">
                  Mon Compte
                </Button>
              </Link>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="outline" className="border-zinc-700 text-white hover:bg-zinc-800">
                    Connexion
                  </Button>
                </Link>
                <Link to="/contact">
                  <Button className="bg-red-600 hover:bg-red-700 text-white">
                    Réserver
                  </Button>
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-white hover:text-red-600 transition-colors"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden py-6 border-t border-zinc-800">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`text-base font-medium transition-colors hover:text-red-600 ${
                    isActive(link.path) ? 'text-red-600' : 'text-gray-300'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="pt-4 flex flex-col space-y-3">
                <a
                  href="tel:0489822709"
                  className="flex items-center text-gray-300 hover:text-red-600 transition-colors"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  0489 82 27 09
                </a>
                <Link to="/contact" onClick={() => setIsOpen(false)}>
                  <Button className="w-full bg-red-600 hover:bg-red-700 text-white">
                    Réserver une Séance
                  </Button>
                </Link>
                
                {/* Member Access Links */}
                <div className="pt-4 border-t border-zinc-800">
                  <p className="text-xs text-gray-400 mb-3">Déjà membre ?</p>
                  <Link to="/login" onClick={() => setIsOpen(false)}>
                    <Button variant="outline" className="w-full border-zinc-700 text-white hover:bg-zinc-800 mb-2 flex items-center justify-center gap-2">
                      <Users className="w-4 h-4" />
                      Se Connecter / Créer un compte
                    </Button>
                  </Link>
                  <Link to="/admin/login" onClick={() => setIsOpen(false)}>
                    <Button variant="outline" className="w-full border-zinc-700 text-gray-400 hover:bg-zinc-800 text-sm flex items-center justify-center gap-2">
                      <Trophy className="w-4 h-4" />
                      Accès Coach
                    </Button>
                  </Link>
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
